import { createReducer, on } from '@ngrx/store';

import { LogType } from '@vi-iot/ui';
import { logger } from '@vi-iot/ui/services/logger.service';

import { OperatingModesActions } from './operating-modes.actions';
import { OperatingModesState } from './operating-modes.state';

export const initOperatingModesState: OperatingModesState = {
  installation: {},
};

/* eslint-disable */
export const operatingModesReducer = createReducer(
  initOperatingModesState,
  on(OperatingModesActions.listFeatures, (state) => ({ ...state })),
  on(OperatingModesActions.listFeaturesSuccess, (state, { gatewaySerial, operatingModes }) => {
    const serial = gatewaySerial;
    delete state.installation[serial];
    state.installation[serial] = operatingModes;

    return {
      ...state,
    };
  }),
  on(OperatingModesActions.listFeaturesError, (state) => ({ ...state })),
  on(OperatingModesActions.liveUpdateFeature, (state, { gatewaySerial, feature, featureName }) => {
    const gwSerial = gatewaySerial;
    const modes = { ...state.installation[gwSerial] };

    logger.log('old value', LogType.info);
    logger.log(state.installation[gwSerial], LogType.info);
    logger.log('---------------------------------', LogType.info);

    for (const circuitId in modes.mode) {
      if (
        modes &&
        modes.mode.hasOwnProperty(circuitId) &&
        modes.mode[circuitId] &&
        modes.mode[circuitId].feature === featureName
      ) {
        modes.mode[circuitId] = { ...feature };
      }
    }
    delete state.installation[gwSerial];
    state.installation[gwSerial] = modes;

    return {
      ...state,
    };
  })
);
